import {
  DEFAULT_COUNTRY_CODE,
  US_DIAL_CODE,
} from "../../constants/countryCodes";

export function digitsOnly(value: string | null | undefined): string {
  return (value ?? "").replace(/\D/g, "");
}

const US_NATIONAL_DIGIT_LENGTH = 10;

/** Formats a US national number as `000-000-0000` while typing or pasting. */
export function formatUsNationalNumber(
  value: string | null | undefined
): string {
  let digits = digitsOnly(value);

  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }

  digits = digits.slice(0, US_NATIONAL_DIGIT_LENGTH);

  if (digits.length <= 3) {
    return digits;
  }

  if (digits.length <= 6) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}

export function isValidUsNationalNumber(
  value: string | null | undefined
): boolean {
  return digitsOnly(value).length === US_NATIONAL_DIGIT_LENGTH;
}

export function normalizeE164(value: string | null | undefined): string {
  const raw = (value ?? "").trim();
  if (!raw) return "";
  const digits = digitsOnly(raw);
  if (!digits) return "";
  return raw.startsWith("+") ? `+${digits}` : `+${digits}`;
}

export function toE164(_countryCode: string, nationalNumber: string): string {
  const national = digitsOnly(nationalNumber);
  if (!national) return "";
  return `${US_DIAL_CODE}${national}`;
}

export function parsePhoneNumber(phone: string | null | undefined): {
  countryCode: string;
  nationalNumber: string;
} {
  const normalized = normalizeE164(phone);
  if (!normalized) {
    return { countryCode: DEFAULT_COUNTRY_CODE, nationalNumber: "" };
  }

  if (normalized.startsWith(US_DIAL_CODE)) {
    return {
      countryCode: DEFAULT_COUNTRY_CODE,
      nationalNumber: normalized.slice(US_DIAL_CODE.length),
    };
  }

  return {
    countryCode: DEFAULT_COUNTRY_CODE,
    nationalNumber: digitsOnly(normalized),
  };
}

export function formatPhoneForDisplay(
  phone: string | null | undefined
): string {
  const normalized = normalizeE164(phone);
  if (!normalized) return "---";
  return normalized;
}
